
export const hasPermission = (permission_codename:string, perimssion_list:Array<string>) => {
    return perimssion_list.includes(permission_codename)
}


